// extracted by mini-css-extract-plugin
export default {"container":"SuccessPassword_container__0g3Za","box":"SuccessPassword_box__lj82K"};